var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleTable',{attrs:{"formclass":"ExpertStore/form","endpoint":"expert-stores","aditionalColumns":_vm.headers,"hideNew":!_vm.isAdmin}},[[_c('h1',[_vm._v("Associação: Lojas -> Especialistas")]),_c('v-divider',{staticClass:"mb-4"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }